"use client";

import dynamic from "next/dynamic";
import { useEffect, useState, useRef } from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { Arrow } from "../Review/Arrow";

// Dynamic import for PartnerCard
const PartnerCard = dynamic(() => import("./PartnerCard"));

interface ServicesPartnerSliderProps {
  partnerCards: {
    id: number;
    title: string;
    description: string;
    image: any;
  }[];
}

const ServicesPartnerSlider: React.FC< ServicesPartnerSliderProps> = ({ partnerCards,
 }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    loop: true,
    slides: {
      perView: 3.5,
      origin: "center",
      spacing: 30,
    },
    breakpoints: {
      "(max-width: 1280px)": {
        slides: {
          perView: 3.6,
          origin: "center",
          spacing: 20,
        },
      },
      "(max-width: 768px)": {
        slides: {
          perView: 2.2,
          origin: "center",
          spacing: 15,
        },
      },
      "(max-width: 500px)": {
        slides: {
          perView: 1.5,
          origin: "center",
          spacing: 25,
        },
      },
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });

  // Autoplay every 3 seconds
  useEffect(() => {
    if (!instanceRef.current) return;

    intervalRef.current = setInterval(() => {
      instanceRef.current?.next();
    }, 3000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [instanceRef]);

  return (
    <>
      <div ref={sliderRef} className="keen-slider">
        {partnerCards?.map((card, index) => (
          <div className="keen-slider__slide" key={index}>
            <PartnerCard
              key={index}
              title={card?.title}
              description={card?.description}
              image={card?.image}
            />
          </div>
        ))}
      </div>

      {/* Arrow Navigation */}
      <div className="md:block hidden">
        {loaded && instanceRef.current && (
          <div className="flex justify-center items-center gap-3 mt-10">
            <Arrow
              left
              onClick={(e) => {
                e.stopPropagation();
                instanceRef.current?.prev();
              }}
            />
            <div className="pagination-indicator text-sm font-medium">
              <span className="text-subtitle-1 font-bold text-primary-text-white">
                {currentSlide + 1} /{" "}
                {instanceRef.current.track.details.slides.length}
              </span>
            </div>
            <Arrow
              left={false}
              onClick={(e) => {
                e.stopPropagation();
                instanceRef.current?.next();
              }}
            />
          </div>
        )}
      </div>

      {/* Dot Navigation for Mobile */}
      <div className="md:hidden block pt-[32px]">
        {loaded && instanceRef.current && (
          <div className="flex justify-center items-center gap-[8px] px-[44px] py-[20px] bg-transparent max-w-[334px] m-auto">
            {Array.from({
              length: instanceRef?.current?.track?.details?.slides?.length || 0,
            }).map((_, idx) => (
              <button
                aria-label="dot"
                key={idx}
                onClick={() => instanceRef.current?.moveToIdx(idx)}
                className={`p-0 relative overflow-hidden ${
                  currentSlide === idx
                    ? "flex-1 min-w-[60px] w-16 h-1 transition-none bg-[#E6F3FD]"
                    : "flex-none w-4 h-1 bg-[#E6F3FD]"
                }`}
              >
                <span
                  className={`absolute top-0 left-0 w-full h-1 ${
                    currentSlide === idx
                      ? "[background:linear-gradient(90.07deg,#8ABC00_-6.96%,#0086E6_93.62%)] transition-all duration-[2000ms] delay-[200ms]"
                      : "left-[-100%] transition-none"
                  }`}
                ></span>
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
export default ServicesPartnerSlider;
// function Arrow(props: {
//   left?: boolean;
//   onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
// }) {
//   return (
//     <button
//       aria-label="arrow"
//       className="p-2 border border-border-white opacity-70 hover:opacity-100 cursor-pointer transition-all duration-300"
//       onClick={props.onClick}
//     >
//       <svg
//         className={`arrow ${props.left ? "arrow--left" : "arrow--right"}`}
//         width="24"
//         height="24"
//         viewBox="0 0 24 24"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         {!props.left ? (
//           <>
//             <path
//               d="M14.4301 5.92993L20.5001 11.9999L14.4301 18.0699"
//               stroke="white"
//               strokeWidth="1.8"
//               strokeMiterlimit="10"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               className="stroke-border-white"
//             />
//             <path
//               d="M3.5 12L20.33 12"
//               stroke="white"
//               strokeWidth="1.8"
//               strokeMiterlimit="10"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               className="stroke-border-white"
//             />
//           </>
//         ) : (
//           <>
//             <path
//               d="M9.56995 5.92993L3.49995 11.9999L9.56995 18.0699"
//               stroke="white"
//               strokeWidth="1.8"
//               strokeMiterlimit="10"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               className="stroke-border-white"
//             />
//             <path
//               d="M20.5 12L3.67 12"
//               stroke="white"
//               strokeWidth="1.8"
//               strokeMiterlimit="10"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               className="stroke-border-white"
//             />
//           </>
//         )}
//       </svg>
//     </button>
//   );
// }
